import { render, staticRenderFns } from "./reservations-list.vue?vue&type=template&id=571ab426&scoped=true&"
import script from "./reservations-list.vue?vue&type=script&lang=js&"
export * from "./reservations-list.vue?vue&type=script&lang=js&"
import style0 from "./reservations-list.vue?vue&type=style&index=0&id=571ab426&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571ab426",
  null
  
)

export default component.exports